// extracted by mini-css-extract-plugin
module.exports = {"topbar":"style_topbar__MX9R6","LogoStyle":"style_LogoStyle__2Kbdi"};